import posthog from "posthog-js";

const providers = {
  posthog: true
};

export function dispatch(
  eventName: string,
  properties: Record<string, unknown>
) {
  if (typeof window === "undefined") return;

  if (providers.posthog) posthog.capture(eventName, properties);
}
